import React, { useEffect, useRef, useState, useContext} from 'react';
import { IonApp, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonList, IonButtons, IonButton, IonMenuButton, IonModal, IonLabel, IonText } from '@ionic/react';
import { IonGrid, IonRow, IonCol, IonInput } from '@ionic/react';


import '../../css/layout.css';

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';

 export function ProfileSetting_ContactInfo (props) {

    let authenticatedMerchent_context = useContext(Auth_Zasava_Context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [employeeID, setEmployeeID ] = useState(authenticatedMerchent_context.employeeID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    /*let currentFirstNameRef = useRef();
    let currentLastNameRef = useRef();
    let currentUsernameRef = useRef();
    let currentPasswordRef = useRef();
    let currentPhoneNumberRef = useRef();
    let currentEmailRef = useRef();
    let currentAddressRef = useRef();
    let currentCityRef = useRef();
    let currentCountryRef = useRef();*/

    let [currentFirstName, setCurrentFirstName] = useState(null);
    let [currentLastName, setCurrentLastName] = useState(null);
    let [currentUsername, setCurrentUsername] = useState(null);
    let [currentPassword, setCurrentPassword] = useState(null);
    let [currentPhoneNumber, setCurrentPhoneNumber] = useState(null);
    let [currentEmail, setCurrentEmail] = useState(null);
    let [currentAddressNumber, setCurrentAddressNumber] = useState(null);
    let [currentStreetName, setCurrentStreetName] = useState(null);
    let [currentCity, setCurrentCity] = useState(null);
    let [currentCityDistrict, setCurrentCityDistrict] = useState(null);
    let [currentCountryRegion, setCurrentCountryRegion] = useState(null);
    let [currentCountry, setCurrentCountry] = useState(null);
    let [currentDigitalAddress, setCurrentDigitalAddress] = useState(null);

    let updateFirstNameRef = useRef();
    let updateLastNameRef = useRef();
    let updateUsernameRef = useRef();
    let updatePasswordRef = useRef();
    let updatePhoneNumberRef = useRef();
    let updateEmailRef = useRef();
    let updateAddressNumberRef = useRef();
    let updateStreetNameRef = useRef();
    let updateCityRef = useRef();
    let updateCityDistrictRef = useRef();
    let updateCountryRegionRef = useRef();
    let updateCountryRef = useRef();
    let updateDigitalAddressRef = useRef();

    let [companyRole, setCompanyRole] = useState(null);
    let [hireDate, setHireDate] = useState(null);
    let [hourlyPay, setHourlyPay] = useState(null);
    let [jobFunction, setJobFunction] = useState(null);

    let [currentFirstNameDisplay, setCurrentFirstNameDisplay] = useState('inline-block');
    let [currentLastNameDisplay, setCurrentLastNameDisplay] = useState('inline-block');
    let [currentUsernameDisplay, setCurrentUsernameDisplay] = useState('inline-block');
    let [currentPasswordDisplay, setCurrentPasswordDisplay] = useState('inline-block');
    let [currentPhoneNumberDisplay, setCurrentPhoneNumberDisplay] = useState('inline-block');
    let [currentEmailDisplay, setCurrentEmailDisplay] = useState('inline-block');
    let [currentAddressNumberDisplay, setCurrentAddressNumberDisplay] = useState('inline-block');
    let [currentStreetNameDisplay, setCurrentStreetNameDisplay] = useState('inline-block');
    let [currentCityDisplay, setCurrentCityDisplay] = useState('inline-block');
    let [currentCityDistrictDisplay, setCurrentCityDistrictDisplay] = useState('inline-block');
    let [currentCountryRegionDisplay, setCurrentCountryRegionDisplay] = useState('inline-block');
    let [currentCountryDisplay, setCurrentCountryDisplay] = useState('inline-block');
    let [currentDigitalAddressNumber, setCurrentDigitalAddressNumber] = useState('inline-block');

    let [updateFirstNameDisplay, setUpdateFirstNameDisplay]  = useState('none');
    let [updateLastNameDisplay, setUpdateLastNameDisplay] = useState('none');
    let [updateUsernameDisplay, setUpdateUsernameDisplay] = useState('none');
    let [updatePasswordDisplay, setUpdatePasswordDisplay] = useState('none');
    let [updatePhoneNumberDisplay, setUpdatePhoneNumberDisplay] = useState('none');
    let [updateEmailDisplay, setUpdateEmailDisplay] = useState('none');
    let [updateAddressNumberDisplay, setUpdateAddressNumberDisplay] = useState('none');
    let [updateStreetNameDisplay, setUpdateStreetNameDisplay] = useState('none');
    let [updateCityDisplay, setUpdateCityDisplay] = useState('none');
    let [updateCityDistrictDisplay, setUpdateCityDistrictDisplay] = useState('none');
    let [updateCountryRegionDisplay, setUpdateCountryRegionDisplay] = useState('none');
    let [updateCountryDisplay, setUpdateCountryDisplay] = useState('none');
    let [updateDigitalAddressNumber, setUpdateDigitalAddressNumber] = useState('none');


    let [updateEmployeeProfileDisplay, setUpdateEmployeeProfileDisplay] = useState('inline-block');
    let [submit_cancelEmployeeProfileDisplay, setSubmit_cancelEmployeeProfileDisplay] = useState('none');


    useEffect(() => {

        /*
        let formData = new FormData();
        formData.append('Tracker', 74800);
        formData.append('user', acctID);
        formData.append('xEmployeeID', employeeID);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
        }
        */
       
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74800',
                user: acctID,
                xEmployeeID: employeeID,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'zsava_internal_indexApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            //alert(res);
            
            let rows = res.toString().split('~~~');
            let rowLength = rows.length;

                for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    /*setCompanyRole(cols[1]);
                    setCurrentFirstName(cols[2]);
                    setCurrentLastName(cols[3]);
                    setCurrentUsername(cols[4]);
                    setCurrentPassword(cols[5]);
                    setHireDate(cols[6]);
                    setHourlyPay(cols[7]);
                    setJobFunction(cols[8]);
                    setCurrentPhoneNumber(cols[9]);
                    setCurrentEmail(cols[10]);
                    setCurrentAddress(cols[11]);
                    setCurrentCity(cols[12]);
                    setCurrentCountry(cols[13]);*/

                    setCompanyRole(cols[1]);
                    setCurrentFirstName(cols[2]);
                    setCurrentLastName(cols[3]);
                    setCurrentUsername(cols[4]);
                    setCurrentPassword(cols[5]);
                    setHireDate(cols[6]);
                    setHourlyPay(cols[7]);
                    setJobFunction(cols[8]);
                    setCurrentPhoneNumber(cols[9]);
                    setCurrentEmail(cols[10]);
                    setCurrentAddressNumber(cols[11]);
                    setCurrentStreetName(cols[12]);
                    setCurrentCity(cols[13]);
                    setCurrentCityDistrict(cols[14]);
                    setCurrentCountryRegion(cols[15]);
                    setCurrentCountry(cols[16]);
                    setCurrentDigitalAddress(cols[17]);

                }
        })

    }, [props.openModal]);

    function updateEmployeeProfile()
    {

        setCurrentFirstNameDisplay('none');
        setCurrentLastNameDisplay('none');
        setCurrentUsernameDisplay('none');
        setCurrentPasswordDisplay('none');
        setCurrentPhoneNumberDisplay('none');
        setCurrentEmailDisplay('none');
        setCurrentAddressNumber('none');
        setCurrentCityDisplay('none');
        setCurrentCountryDisplay('none');

        setUpdateFirstNameDisplay('inline-block');
        setUpdateLastNameDisplay('inline-block');
        setUpdateUsernameDisplay('inline-block');
        setUpdatePasswordDisplay('inline-block');
        setUpdatePhoneNumberDisplay('inline-block');
        setUpdateEmailDisplay('inline-block');
        setUpdateAddressNumberDisplay('inline-block');
        setUpdateCityDisplay('inline-block');
        setUpdateCountryDisplay('inline-block');
        setUpdateEmployeeProfileDisplay('inline-block');
        setSubmit_cancelEmployeeProfileDisplay('inline-block');

    }

    function submit_updateEmployeeProfile()
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', 74801);
        formData.append('user', acctID);
        formData.append('xEmployeeID', employeeID);

        formData.append('xEmployeeFirstName', updateFirstNameRef.current.value)
        formData.append('xEmployeeLastName', updateLastNameRef.current.value);
        formData.append('xUpdateUsername', updateUsernameRef.current.value);
        formData.append('xUpdatePassword', updatePasswordRef.current.value);
        formData.append('xEmployeePhoneNumber', updatePhoneNumberRef.current.value);
        formData.append('xEmployeeEmailAddress', updateEmailRef.current.value);
        formData.append('xEmployeeAddressNumber', updateAddressNumberRef.current.value);
        formData.append('xEmployeeStreetName', updateStreetNameRef.current.value);
        formData.append('xEmployeeCity', updateCityRef.current.value);
        formData.append('xEmployeeCityDistrict', updateCityDistrictRef.current.value);
        formData.append('xEmployeeCountryRegion', updateCountryRegionRef.current.value);
        formData.append('xEmployeeCountry', updateCountryRef.current.value);
        formData.append('xEmployeeDigitalAddressID', updateDigitalAddressRef.current.value);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */
       
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74801',
                user: acctID,
                xEmployeeID: employeeID,
                xEmployeeFirstName: updateFirstNameRef.current.value,
                xEmployeeLastName: updateLastNameRef.current.value,
                xUpdateUsername: updateUsernameRef.current.value,
                xUpdatePassword: updatePasswordRef.current.value,
                xEmployeePhoneNumber: updatePhoneNumberRef.current.value,
                xEmployeeEmailAddress: updateAddressNumberRef.current.value,
                xEmployeeAddressNumber: updateAddressNumberRef.current.value,
                xEmployeeStreetName: updateStreetNameRef.current.value,
                xEmployeeCity: updateCityRef.current.value,
                xEmployeeCityDistrict: updateDigitalAddressRef.current.value,
                xEmployeeCountryRegion: updateCountryRegionRef.current.value,
                xEmployeeCountry: updateCountryRef.current.value,
                xEmployeeDigitalAddressID: updateDigitalAddressRef.current.value,
                sessionID: sessionID,

            }),
        }


        fetch(baseURL+'zsava_internal_indexApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');
            let rowLength = rows.length;

                for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setCompanyRole(cols[1]);
                    setCurrentFirstName(cols[2]);
                    setCurrentLastName(cols[3]);
                    setCurrentUsername(cols[4]);
                    setCurrentPassword(cols[5]);
                    setHireDate(cols[6]);
                    setHourlyPay(cols[7]);
                    setJobFunction(cols[8]);
                    setCurrentPhoneNumber(cols[9]);
                    setCurrentEmail(cols[10]);
                    setCurrentAddressNumber(cols[11]);
                    setCurrentStreetName(cols[12]);
                    setCurrentCity(cols[13]);
                    setCurrentCityDistrict(cols[14]);
                    setCurrentCountryRegion(cols[15]);
                    setCurrentCountry(cols[16]);
                    setCurrentDigitalAddress(cols[17]);
                }
        })
    }

    function cancel_updateEmployeeProfile()
    {


        setCurrentFirstNameDisplay('inline-block');
        setCurrentLastNameDisplay('inline-block');
        setCurrentUsernameDisplay('inline-block');
        setCurrentPasswordDisplay('inline-block');
        setCurrentPhoneNumberDisplay('inline-block');
        setCurrentEmailDisplay('inline-block');
        setCurrentAddressNumberDisplay('inline-block');
        setCurrentStreetNameDisplay('inline-block');
        currentCityDisplay('inline-block');
        currentCityDistrictDisplay('inline-block');
        currentCountryRegionDisplay('inline-block');
        currentCountryDisplay('inline-block');
        currentDigitalAddressNumber('inline-block');

        updateFirstNameDisplay('none');
        updateLastNameDisplay('none');
        updateUsernameDisplay('none');
        updatePasswordDisplay('none');
        updatePhoneNumberDisplay('none');
        updateEmailDisplay('none');
        updateAddressNumberDisplay('none');
        updateStreetNameDisplay('none');
        updateCityDisplay('none');
        updateCityDistrictDisplay('none');
        updateCountryRegionDisplay('none');
        updateCountryDisplay('none');
        updateDigitalAddressNumber('none');
        updateEmployeeProfileDisplay('none');
        submit_cancelEmployeeProfileDisplay('none');
    }

    //const xTracker = Tracker;
    //const xUsername = pUsername;
    //const xPassword = pPassword;

    //alert('In Profile Setting');
    //alert(updateEmployeeProfileDisplay);
    //alert(schema);

    return (

        <React.Fragment>
            
                        
        {props.openModal == true ?
        (
            <IonModal className='appModal' isOpen={ props.openModal }>
                <IonList className='ProfileSetting_contactInfoCss'>
                        <IonItem>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='4'>
                                        <IonLabel > First Name: </IonLabel>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonText style={{display: currentFirstNameDisplay}}> {currentFirstName} </IonText>
                                        <IonInput style={{display: updateFirstNameDisplay}} type='text' placeholder={currentFirstName} ref={updateFirstNameRef}></IonInput>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonButton onClick={() => setUpdateFirstNameDisplay('inline-block')} > Update </IonButton>
                                        <IonButton style={{display: updateFirstNameDisplay}} onClick={() => setUpdateFirstNameDisplay('none')}> Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonItem>
                        <IonItem>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='4'>
                                        <IonLabel> Last Name: </IonLabel>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonText style={{display: currentLastNameDisplay}}> {currentLastName} </IonText>
                                        <IonInput style={{display: updateLastNameDisplay}} type='text' placeholder={currentLastName} ref={updateLastNameRef}></IonInput>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonButton onClick={() => setUpdateLastNameDisplay('inline-block')} > Update </IonButton>
                                        <IonButton style={{display: updateLastNameDisplay}} onClick={() => setUpdateLastNameDisplay('none')}> Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonItem>
                        <IonItem>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='4'>
                                        <IonLabel >Username: </IonLabel>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonText style={{display: currentUsernameDisplay}}> {currentUsername} </IonText>
                                        <IonInput style={{display: updateUsernameDisplay}} type='text' placeholder={currentUsername} ref={updateUsernameRef}></IonInput>                       
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonButton onClick={() => setUpdateUsernameDisplay('inline-block')} > Update </IonButton>
                                        <IonButton style={{display: updateUsernameDisplay}} onClick={() => setUpdateUsernameDisplay('none')}> Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonItem>
                        <IonItem>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='4'>
                                        <IonLabel >Password: </IonLabel>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonText style={{display: currentPasswordDisplay}}> {currentPassword} </IonText>
                                        <IonInput style={{display: updatePasswordDisplay}} type='text' placeholder={currentPassword} ref={updatePasswordRef}></IonInput>                       
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonButton onClick={() => setUpdatePasswordDisplay('inline-block')} > Update </IonButton>
                                        <IonButton style={{display: updatePasswordDisplay}} onClick={() => setUpdatePasswordDisplay('none')}> Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonItem>
                        <IonItem>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='4'>
                                        <IonLabel >Personal Phone Number: </IonLabel>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonText style={{display: currentPhoneNumberDisplay}}> {currentPhoneNumber} </IonText>
                                        <IonInput style={{display: updatePhoneNumberDisplay}} type='text' placeholder={currentPhoneNumber} ref={updatePhoneNumberRef}></IonInput>                       
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonButton onClick={() => setUpdatePhoneNumberDisplay('inline-block')} > Update </IonButton>
                                        <IonButton style={{display: updatePhoneNumberDisplay}} onClick={() => setUpdatePhoneNumberDisplay('none')}> Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonItem>
                        <IonItem>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='4'>
                                        <IonLabel>Personal Email Address: </IonLabel>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonText style={{display: currentEmailDisplay}}> {currentEmail} </IonText>
                                        <IonInput style={{display: updateEmailDisplay}} type='text' placeholder={currentEmail} ref={updateEmailRef}></IonInput>                       
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonButton onClick={() => setUpdateEmailDisplay('inline-block')} > Update </IonButton>
                                        <IonButton style={{display: updateEmailDisplay}} onClick={() => setUpdateEmailDisplay('none')}> Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonItem>
                        <IonItem>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='4'>
                                        <IonLabel >Address Number: </IonLabel>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonText style={{display: currentAddressNumberDisplay}}> {currentAddressNumber} </IonText>
                                        <IonInput style={{display: updateAddressNumberDisplay}} type='text' placeholder={currentAddressNumber} ref={updateAddressNumberRef}></IonInput>                       
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonButton onClick={() => setUpdateAddressNumberDisplay('inline-block')} > Update </IonButton>
                                        <IonButton style={{display: updateAddressNumberDisplay}} onClick={() => setUpdateAddressNumberDisplay('none')}> Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonItem>
                        <IonItem>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='4'>
                                        <IonLabel >Street Name: </IonLabel>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonText style={{display: currentStreetNameDisplay}}> {currentStreetName} </IonText>
                                        <IonInput style={{display: updateStreetNameDisplay}} type='text' placeholder={currentStreetName} ref={updateStreetNameRef}></IonInput>                       
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonButton onClick={() => setUpdateStreetNameDisplay('inline-block')} > Update </IonButton>
                                        <IonButton style={{display: updateAddressNumberDisplay}} onClick={() => setUpdateAddressNumberDisplay('none')}> Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonItem>
                        <IonItem>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='4'>
                                        <IonLabel >City: </IonLabel>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonText style={{display: currentCityDisplay}}> {currentCity} </IonText>
                                        <IonInput style={{display: updateCityDisplay}} type='text' placeholder={currentCity} ref={updateCityRef}></IonInput>                       
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonButton onClick={() => setUpdateCityDisplay('inline-block')} > Update </IonButton>
                                        <IonButton style={{display: updateCityDisplay}} onClick={() => setUpdateCityDisplay('none')}> Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonItem>
                        <IonItem>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='4'>
                                        <IonLabel >City District: </IonLabel>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonText style={{display: currentCityDistrictDisplay}}> {currentCityDistrict} </IonText>
                                        <IonInput style={{display: updateCityDistrictDisplay}} type='text' placeholder={currentCityDistrict} ref={updateCityDistrictRef}></IonInput>                       
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonButton onClick={() => setUpdateCityDistrictDisplay('inline-block')} > Update </IonButton>
                                        <IonButton style={{display: updateCityDistrictDisplay}} onClick={() => setUpdateCityDistrictDisplay('none')}> Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonItem>
                        <IonItem>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='4'>
                                        <IonLabel >Country Region: </IonLabel>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonText style={{display: currentCountryRegionDisplay}}> {currentCountryRegion} </IonText>
                                        <IonInput style={{display: updateCountryRegionDisplay}} type='text' placeholder={currentCountryRegion} ref={updateCountryRegionRef}></IonInput>                       
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonButton onClick={() => setUpdateCountryRegionDisplay('inline-block')} > Update </IonButton>
                                        <IonButton style={{display: updateCountryRegionDisplay}} onClick={() => setUpdateCountryRegionDisplay('none')}> Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonItem>
                        <IonItem>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='4'>
                                        <IonLabel >Country: </IonLabel>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonText style={{display: currentCountryDisplay}}> {currentCountry} </IonText>
                                        <IonInput style={{display: updateCountryDisplay}} type='text' placeholder={currentCountry} ref={updateCountryRef}></IonInput>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonButton onClick={() => setUpdateCountryDisplay('inline-block')} > Update </IonButton>
                                        <IonButton style={{display: updateCountryDisplay}} onClick={() => setUpdateCountryDisplay('none')}> Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonItem>
                        <IonItem>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='4'>
                                        <IonLabel >Digital Address: </IonLabel>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonText style={{display: currentDigitalAddressNumber}}> {currentDigitalAddress} </IonText>
                                        <IonInput style={{display: updateDigitalAddressNumber}} type='text' placeholder={currentDigitalAddress} ref={updateDigitalAddressRef}></IonInput>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonButton onClick={() => setUpdateDigitalAddressNumber('inline-block')} > Update </IonButton>
                                        <IonButton style={{display: updateDigitalAddressNumber}} onClick={() => setUpdateDigitalAddressNumber('none')}> Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonItem>
                        <IonItem>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <IonButton style={{display: updateEmployeeProfileDisplay}} onClick={() => cancel_updateEmployeeProfile()}>Reset</IonButton>
                                    </IonCol>
                                    <IonCol>
                                        <IonButton style={{display: updateEmployeeProfileDisplay}} onClick={() => submit_updateEmployeeProfile()}>Save Changes</IonButton>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonButton style={{display: updateEmployeeProfileDisplay}} onClick={() => props.closeModal()}> Close </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                            {/*<IonButton style={{display: submit_cancelEmployeeProfileDisplay}} onClick={() => cancel_updateEmployeeProfile()}>Cancel</IonButton>
                            <IonButton style={{display: submit_cancelEmployeeProfileDisplay}} onClick={() => submit_updateEmployeeProfile()}>Save Changes</IonButton>*/}
                        </IonItem>
                    </IonList>
                </IonModal>
           
        ) : null }
    </React.Fragment>

    );
};
